import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppNewsModel } from '@bo-client/shared/app-news/app-news.model';
import { AppNewsService } from '@bo-client/shared/app-news/app-news.service';

/**
 * Eingaben des Neuigkeiten-Modals: Entweder bereits geladene `news` (automatisches Öffnen beim
 * App-Start) oder nur `size`, dann lädt das Modal selbst (Benutzermenü).
 */
export interface AppNewsModalData {
  size: number;
  news?: AppNewsModel[];
}

/**
 * Zeigt veröffentlichte Neuigkeiten. Eine einzelne Neuigkeit füllt das Modal direkt (Titel, Datum,
 * Beschreibung); mehrere stehen als Expansion Panels untereinander, eingeklappt mit Titel und Datum,
 * aufgeklappt zusätzlich mit der Beschreibung. Was beim Schließen passiert, regelt der Aufrufer
 * (`AppNewsViewerService`).
 */
@Component({
  selector: 'app-news-modal',
  templateUrl: './app-news-modal.component.html',
  styleUrls: ['./app-news-modal.component.scss']
})
export class AppNewsModalComponent implements OnInit {
  private appNewsService = inject(AppNewsService);
  private destroyRef = inject(DestroyRef);

  /** `null`, solange geladen wird. */
  news: AppNewsModel[] | null = null;
  loadFailed = false;

  /** Die Neuigkeit, wenn es genau eine gibt; dann ohne Expansion Panel. */
  get singleNews(): AppNewsModel | null {
    return this.news?.length === 1 ? this.news[0] : null;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: AppNewsModalData) {}

  ngOnInit(): void {
    if (this.data.news) {
      this.news = this.data.news;
      return;
    }
    this.appNewsService
      .getPublished(this.data.size)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (news) => (this.news = news),
        error: () => {
          this.news = [];
          this.loadFailed = true;
        }
      });
  }
}
